module.exports = __webpack_public_path__ + "static/media/ss2_preview.80b64e1a.jpg";